// 环境配置工具类
export class EnvConfig {
    // API配置
    static get apiUrl() {
        return process.env.REACT_APP_API_BASE_URL || "/api";
    }
    static get apiBaseUrl() {
        return process.env.REACT_APP_API_BASE_URL || "http://39.99.230.187:8033";
    }
    static get wsUrl() {
        return process.env.REACT_APP_WS_URL || "ws://localhost:3001/ws";
    }
    static get modelFileUrl() {
        return process.env.REACT_APP_MODEL_URL || "";
    }
    // 应用配置
    static get appTitle() {
        return process.env.REACT_APP_TITLE || "数据大屏监控平台";
    }
    static get appVersion() {
        return process.env.REACT_APP_VERSION || "1.0.0";
    }
    static get environment() {
        return process.env.REACT_APP_ENV || "development";
    }
    // 轮询间隔
    static get pollingInterval() {
        return parseInt(process.env.REACT_APP_POLLING_INTERVAL || "5000");
    }
    static get heartbeatInterval() {
        return parseInt(process.env.REACT_APP_HEARTBEAT_INTERVAL || "30000");
    }
    // 环境判断
    static get isDevelopment() {
        return this.environment === "development";
    }
    static get isProduction() {
        return this.environment === "production";
    }
    static get isTest() {
        return this.environment === "test";
    }
    static get isStaging() {
        return this.environment === "staging";
    }
    // 获取所有配置
    static getAllConfig() {
        return {
            apiBaseUrl: this.apiBaseUrl,
            apiUrl: this.apiUrl,
            wsUrl: this.wsUrl,
            appTitle: this.appTitle,
            appVersion: this.appVersion,
            environment: this.environment,
            pollingInterval: this.pollingInterval,
            heartbeatInterval: this.heartbeatInterval,
            isDevelopment: this.isDevelopment,
            isProduction: this.isProduction,
            isTest: this.isTest,
            isStaging: this.isStaging,
            modelFileUrl: this.modelFileUrl
        };
    }
    // 打印配置信息
    static printConfig() {
        console.group("🔧 环境配置信息");
        console.table(this.getAllConfig());
        console.groupEnd();
    }
}
